<ng-container *ngIf="termsExists">
  <nb-card>
    <nb-card-header i18n="@@Synonyms" style="border: none">Синонимы</nb-card-header>
    <nb-card-body style="padding: 4px !important; display: block">

      <input i18n-placeholder="@@AddSynonymName" [formControl]="inputFormControl"
             nbInput
             type="text"
             fieldSize="small"
             placeholder="Введите синоним"
             [nbAutocomplete]="auto"
      />
      <br>
      <nb-autocomplete #auto (selectedChange)="insertTerm($event)" [handleDisplayFn]="viewHandle">
        <nb-option *ngFor="let term of terms$ | async" [value]="term">
          {{ term.header }}
        </nb-option>
      </nb-autocomplete>

      <ng-container *ngIf="model?.terms?.length">
        <nb-tag-list>
          <nb-tag *ngFor="let term of model.terms" (remove)="removeTerm(term)" [removable]="true" [text]="term.header"/>
        </nb-tag-list>
      </ng-container>
    </nb-card-body>
  </nb-card>
</ng-container>
